import { createContext, FC, useCallback, useContext, useEffect, useMemo, useState } from 'react';

import { ISetUpPasswordContextProps as IProps } from './types';

const setUpPasswordContext = createContext<{
  step: number;
  nextStep: () => void;
  prevStep: () => void;
}>({
  step: 0,
  nextStep: () => {},
  prevStep: () => {},
});

export const useSetUpPasswordContext = () => useContext(setUpPasswordContext);

export const SetUpPasswordContextProvider: FC<IProps> = ({ children, isModalOpened }) => {
  const [passwordContext, setPasswordContext] = useState({
    step: 0,
  });

  const nextStep = useCallback(() => {
    setPasswordContext((prev) => ({
      step: prev.step + 1,
    }));
  }, []);

  const prevStep = useCallback(() => {
    setPasswordContext((prev) => ({
      step: prev.step - 1,
    }));
  }, []);

  useEffect(() => {
    if (!isModalOpened) {
      setPasswordContext({ step: 0 });
    }
  }, [isModalOpened]);

  return (
    <setUpPasswordContext.Provider
      value={useMemo(() => ({ ...passwordContext, nextStep, prevStep }), [passwordContext, nextStep, prevStep])}
    >
      {children}
    </setUpPasswordContext.Provider>
  );
};
